import React, { useState } from 'react';
import { WMSFetch } from '../../utils/common-api-calls';
import { PAGE_TYPES, QUOTE_LINE_SELECTED_STATES } from '../../pages/WMS_SMS/data';

export default function BackButton({ data, currentUser, setAutoQuoteData, setData, setActivePage, setShowNotification }) {
    const [loadingBack, setLoadingBack] = useState(false);

    const resetPageAndReturnToLines = async () => {
        try {
            setLoadingBack(true);
            const body = {
                autoIds: data.quotes
                    .map((quote) => quote.autoId)
                    .filter((quote) => quote.selectedState !== QUOTE_LINE_SELECTED_STATES.LOCKED),
                isTempLocked: false,
            };
            const response = await WMSFetch('wms/sms/toggle-temp-lock-status-and-fetch-updates', body, currentUser);
            if (response?.error) {
                throw Error(response.Error);
            }

            const quoteLineNames = response?.data?.map((line) => line.quoteLineNumber);
            setAutoQuoteData((data) => {
                return data.map((quoteLine) => {
                    if (quoteLineNames.includes(quoteLine.quoteLineName)) {
                        const matchingQuoteLine = response?.data?.find(
                            (quote) => quoteLine.quoteLineName === quote.quoteLineNumber
                        );
                        if (matchingQuoteLine) {
                            return {
                                ...quoteLine,
                                requestedDate: matchingQuoteLine.requestedDate,
                                selectedState: matchingQuoteLine.selectedState,
                                tempLock: matchingQuoteLine.tempLock,
                            };
                        }
                    }
                    return quoteLine;
                });
            });
            setData(null);
            setActivePage(PAGE_TYPES.QUOTE_GRID);
        } catch (error) {
            setShowNotification({
                shown: true,
                status: 'error',
                title: 'Error updating temporary lock statuses',
                message:
                    'An error has occured updating the temporary lock statuses for current quote lines. If the error persists please refresh the page.',
            });
        } finally {
            setLoadingBack(false);
        }
    };

    return (
        <button
            disabled={loadingBack}
            className='px-4 py-2 text-white rounded-md bg-blue-primary'
            onClick={() => resetPageAndReturnToLines()}
        >
            {loadingBack ? 'Loading...' : 'Back'}
        </button>
    );
}
